// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAzAF5BGQTXj7AD99JFAI0GfJxcjG20B7U",
  authDomain: "yathartha.firebaseapp.com",
  projectId: "yathartha",
  storageBucket: "yathartha.firebasestorage.app",
  messagingSenderId: "55223499494",
  appId: "1:55223499494:web:4c6b1fcaba86ffb04c1927",
  measurementId: "G-WBE3TGB34M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export auth and firestore for use in the app
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;